module.exports = __webpack_public_path__ + "img/20400.80dd5247.jpg";